<template>
  <div class="container">
    <v-flex xs12 sm6 d-flex>
      <br />
      <v-select
        v-model="select"
        :items="$store.state.data.labels"
        box
        class="dropdown"
        label="Sector de Riego"
        @input="getHistoricData(select)"
      />
    </v-flex>
    <v-card>
      <div
        v-if="$store.state.subProject"
        id="historic"
        style="width:100%; padding-top:20px; height:350px;"
      />
    </v-card>
  </div>
</template>

<script>
const moment = require("moment-timezone");

const DATE_FORMAT = " MMMM, D, h:mmA";

export default {
  data() {
    return {
      historic: null,
      modal: null,
      select: null,
      select2: null,
      date: null,
      date2: null,
      date3: null,
      date4: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      ready: false,
      ready2: false,
    };
  },
  methods: {
    getHistoricData: async function(select) {
      console.log("CREATED");
      console.log(select);
      this.selectedIndex = this.$store.state.devices
        .map(function(e) {
          return e.name;
        })
        .indexOf(select);

      this.historic = (
        await this.$axios.get(
          `/api/IrrigationReportsAll/${this.selectedIndex + 1}/${
            this.$store.state.subProject
          }`
        )
      ).data;
      console.log(this.historic);
      this.populateHistoric();
    },
    onClick() {
      this.$refs.menu.save(this.date);
      console.log("CHUY", new Date(this.date).toISOString());
    },
    onClick2() {
      this.$refs.menu2.save(this.date2);
      this.ready = true;
      console.log("CHUY2", this.date2);
    },
    onClick3() {
      this.$refs.menu3.save(this.date3);
      console.log("CHUY", new Date(this.date3).toISOString());
    },
    onClick4() {
      this.$refs.menu4.save(this.date4);
      this.ready2 = true;
      console.log("CHUY2", this.date4);
    },
    async click() {
      let id = this.$store.state.devices.find((x) => x.name === this.select)
        .sigfoxId;
      console.log(id);

      let params = {
        sigfoxDeviceId: id,
        startDate: new Date(this.date).toISOString().toString(),
        endDate: new Date(this.date2).toISOString().toString(),
      };

      console.log(params);

      let date = [];
      let humedad = [];
      let ce = [];
      let res = [];

      await this.$axios
        .get(`https://listener.rabiahostal.com.mx/api/message/get-by-device`, {
          params,
        })
        .then((data) => {
          res = data.data;
          console.log("TEST", res);
          // date = res.map(x => new Date(x.date.toString()))
          humedad = res.map((x) => {
            return (x.humidity / 30) * 0.5 * 100;
          });
          ce = res.map((x) => {
            return x.electricConductivity / 1000;
          });

          console.log(date);
          console.log(humedad);
          console.log(ce);
          this.modal = true;
        });
      this.populateChart(date, humedad, ce, res);
    },
    click2() {
      let params = {
        sigfoxDeviceId: this.select2,
        startDate: new Date(this.date3).toISOString().toString(),
        endDate: new Date(this.date4).toISOString().toString(),
      };
      console.log(params);
    },
    populateHistoric: async function() {
      let balance = await this.historic.map((x) => parseInt(x.balance));
      let gotero = await this.historic.map((x) => parseInt(x["mg Na riego"]));
      let drenaje = await this.historic.map((x) =>
        parseInt(x["mg Na drenaje"])
      );
      const categories = await this.historic.map((x) => {
        const formatted = moment(x.createdAt).format(DATE_FORMAT);
        return formatted;
      });
      console.log(categories);

      this.$Highcharts.chart("historic", {
        chart: {
          type: "line",
          zoomType: "xy",
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          text: "Na",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: categories,
          labels: {
            step: 20,
          },
        },
        yAxis: {
          title: {
            text: "mg",
          },
          plotLines: [],
        },
        series: [
          {
            data: gotero,
            name: "Na Gotero",
          },
          {
            data: drenaje,
            name: "Na Drenaje",
          },
          {
            data: balance,
            name: "Balance",
          },
        ],
      });
    },
    populateChart(date, humedad, ce, res) {
      const categories = res.map((x) => {
        const formatted = moment(x.date).format(DATE_FORMAT);
        return formatted;
      });

      this.$Highcharts.chart("humedad", {
        chart: {
          type: "line",
          zoomType: "xy",
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          text: "CE",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
          labels: {
            step: 20,
          },
        },
        yAxis: {
          title: {
            text: "%",
          },
          plotLines: [
            {
              zIndex: 4,
              dashStyle: "Dash",
              color: "#FF0000",
              width: 1,
              value: 1.5,
              label: {
                text: "Capacidad de campo inferior",
                align: "right",
              },
            },
          ],
        },
        series: [
          {
            data: ce,
            name: "CE",
          },
        ],
      });
      this.$Highcharts.chart("ce", {
        chart: {
          type: "line",
          zoomType: "xy",
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          text: "CE",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
        },
        yAxis: {
          // min: 0,
          // max: 10,
          title: {
            text: "dS/m",
          },
          plotLines: [
            {
              zIndex: 3,
              dashStyle: "Dash",
              color: "#FF0000",
              width: 1,
              value: 50,
              label: {
                text: 50,
                align: "right",
              },
            },
          ],
        },
        series: [
          {
            // showInLegend: true,
            data: ce,
            name: "Conductividad Èlectrica",
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.container {
  height: 1100px !important;
}

.dropdown {
  /* margin-top: 10px !important; */
  padding-top: 40px !important;
}
</style>
